import dayjs from "dayjs";

export const getGrantFeePeriodsDayjs = (startDate, endDate) => {
  // Pastikan tanggal valid dan bukan null
  if (
    !startDate ||
    !endDate ||
    !dayjs(startDate).isValid() ||
    !dayjs(endDate).isValid()
  ) {
    return [];
  }

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  const periodsByYear = {};
  let currentDate = start;

  // Set locale ke bahasa Indonesia untuk mendapatkan nama bulan yang benar
  currentDate = currentDate.locale("id");

  // Lakukan loop selama tanggal saat ini tidak melewati tanggal akhir
  while (!currentDate.isAfter(end, "month")) {
    const year = currentDate.year();
    const monthName = currentDate.format("MMMM"); // format 'MMMM' memberikan nama bulan lengkap

    if (!periodsByYear[year]) {
      periodsByYear[year] = [];
    }

    // Hindari duplikasi bulan jika loop berjalan lebih dari sekali pada bulan yang sama
    if (!periodsByYear[year].includes(monthName)) {
      periodsByYear[year].push(monthName);
    }

    // Pindah ke bulan berikutnya
    currentDate = currentDate.add(1, "month");
  }

  // Ubah format objek menjadi array agar mudah di-render
  return Object.entries(periodsByYear).map(([year, months]) => ({
    year: parseInt(year, 10),
    months: months,
  }));
};

export const getYearlySettingsTemplate = (startDate, endDate) => {
  if (
    !startDate ||
    !endDate ||
    !dayjs(startDate).isValid() ||
    !dayjs(endDate).isValid()
  ) {
    return []; // Kembalikan array kosong jika tanggal tidak valid
  }

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  // Objek untuk mengumpulkan semua bulan per tahun
  const periodsByYear = {};
  let currentDate = start.locale("id"); // Set locale ke 'id'

  while (!currentDate.isAfter(end, "month")) {
    const year = currentDate.year();
    const monthName = currentDate.format("MMMM");

    if (!periodsByYear[year]) {
      periodsByYear[year] = [];
    }

    if (!periodsByYear[year].includes(monthName)) {
      periodsByYear[year].push(monthName);
    }

    currentDate = currentDate.add(1, "month");
  }

  // **BAGIAN UTAMA**: Ubah data yang terkumpul menjadi format yang diinginkan
  return Object.entries(periodsByYear).map(([year, months]) => ({
    year: parseInt(year, 10),
    months: months,
    // Ambil bulan pertama dan terakhir dari array 'months'
    start_period: months[0],
    end_period: months[months.length - 1],
    // Siapkan field lain sesuai struktur Redux Anda
    grant_fee: "",
    due_date: "",
    fulfillment_date: "",
    effidence: {
      file: "",
      url: "",
    },
    status: "",
  }));
};

// Format tanggal pendek Indonesia, mis. "20 Okt 2026"; "—" jika kosong
export function formatDate(dateStr) {
  if (!dateStr) return "—";
  try {
    return new Date(dateStr).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
}
